import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { ExpandMore, ExpandLess } from '@mui/icons-material'

const NavItemWithSubmenu = ({ icon, to, title, subItems = [] }) => {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const isFromDepositReceipts = location.state?.from === 'deposit-receipts'

  // Auto-open submenu when on a deposit-receipts page
  useEffect(() => {
    if (location.pathname.includes('deposit-receipts') || isFromDepositReceipts) {
      setOpen(true)
    }
  }, [location.pathname, isFromDepositReceipts])

  const handleNavigate = () => {
    navigate(to)
  }

  const handleToggle = (e) => {
    e.stopPropagation()
    setOpen(!open)
  }

  const isParentActive =
    location.pathname.startsWith('/deals') && !isFromDepositReceipts && !location.pathname.includes('deposit-receipts')

  return (
    <li className="nav-item nav-item-submenu">
      <div className={`nav-item-parent ${isParentActive ? 'active' : ''}`} onClick={handleNavigate}>
        {icon}
        <span>{title}</span>
        <span onClick={handleToggle} style={{ marginLeft: 'auto', marginRight: 12, display: 'flex', alignItems: 'center' }}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </span>
      </div>
      {open && (
        <ul className="nav-submenu">
          {subItems.map((item) => (
            <li key={item.to} className="nav-item">
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  isActive || (item.to === '/deals/deposit-receipts' && isFromDepositReceipts) ? 'active' : ''
                }
              >
                <span>{item.title}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}

export default NavItemWithSubmenu
